import { useTranslation } from 'react-i18next'

import { Status } from '../../../Status'

import { ENTITY_EXTRA_TAGS_ITEM_STATUS_COLORS } from './EntityExtraTagsItemStatuses.constants'

import * as styles from './EntityExtraTagsItemStatuses.module.css'

function EntityExtraTagsItemStatuses({ errorCount, height, newCount }) {
  const { t } = useTranslation()

  return (
    <div className={styles.statuses}>
      {newCount ? (
        <Status
          {...ENTITY_EXTRA_TAGS_ITEM_STATUS_COLORS.new}
          height={height}
          text={t('Table.TagNewCount', { count: newCount })}
        />
      ) : null}
      {errorCount ? (
        <Status
          {...ENTITY_EXTRA_TAGS_ITEM_STATUS_COLORS.error}
          height={height}
          text={t('Table.TagErrorCount', { count: errorCount })}
        />
      ) : null}
    </div>
  )
}

export default EntityExtraTagsItemStatuses
